namespace GeniuzPOS.Purchase {
    export interface PoSupplierForm {
        SupplId: Serenity.StringEditor;
        SupplType: Serenity.LookupEditor;
        SupplName: Serenity.StringEditor;
        SupTelNo: Serenity.StringEditor;
        SupplRegName: Serenity.StringEditor;
        SupplRegAddress: Serenity.TextAreaEditor;
        SupplTaxId: Serenity.StringEditor;
        BranchCode: Serenity.StringEditor;
        BranchName: Serenity.StringEditor;
        ConsignFg: Serenity.BooleanEditor;
        ConsignGp: Serenity.DecimalEditor;
        PayMethod: Serenity.LookupEditor;
        PurVatType: Serenity.LookupEditor;
        PurVatCode: Serenity.LookupEditor;
    }

    export class PoSupplierForm extends Serenity.PrefixedContext {
        static formKey = 'Purchase.PoSupplier';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PoSupplierForm.init)  {
                PoSupplierForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = s.TextAreaEditor;
                var w3 = s.BooleanEditor;
                var w4 = s.DecimalEditor;

                Q.initFormType(PoSupplierForm, [
                    'SupplId', w0,
                    'SupplType', w1,
                    'SupplName', w0,
                    'SupTelNo', w0,
                    'SupplRegName', w0,
                    'SupplRegAddress', w2,
                    'SupplTaxId', w0,
                    'BranchCode', w0,
                    'BranchName', w0,
                    'ConsignFg', w3,
                    'ConsignGp', w4,
                    'PayMethod', w1,
                    'PurVatType', w1,
                    'PurVatCode', w1
                ]);
            }
        }
    }
}
